// BIG TODO: FIX every type related to ObjectTypes to use ObjectTypes enum instead of number
export enum ObjectTypes {
    UNASSIGNED = 0,
    WIRE = 1,
    RUNDOWN = 2,
    SCRIPT = 3,
    AUDIO = 4,
    VIDEO = 5,
    PICTURE = 6,
    READIN = 7,
    PLANNING = 8,
    MESSAGE = 9,
    GRID = 10,
    CONTACT = 11,
    NGGRID = 12,
    MOSOBJ = 13,
    ELECTION = 14,
    MOSOBJR = 15,
    OPENS = 16,
    APWORKBENCH = 17,
    EXTERNAL = 18,
    NONENPS = 19,
    STORYBOARD = 20,
    SEARCH = 21,
    GLOBALMACRO = 22,
    RUNDOWNMACRO = 23,
    STORYMACRO = 24,
    SOCIALMEDIAPOST = 25,
    SOCIALMEDIACOLLECTION = 26,
    USER = 29,
    PERSONALFOLDER = 110,
    PRINTER = 111,
    WIREFOLDER = 112,
    TRASHOPEN = 113,
    TRASHCLOSED = 114,
    LOCATIONS = 115,
    HOMEFOLDER = 116,
    GROUPFOLDER = 117,
    MOSLOGO = 118,
    DIRECTOR = 119,
    EDITOR = 120,
    RESEARCHER = 121,
    LOCATIONFOLDER = 122,
    WELCOME = 123,
    VOIPMESSAGE = 124,
    COMMCENTER = 125,
    TOOLBOX = 126,
    MACRO = 127,
    SCHEDULER = 128,
    MYENPS = 131,
    SOCIALMEDIA = 132,
    COLLECTIONCOLUMN = 133,
    TOPIC = 137,
    ASSIGNMENT = 138,
    PSTVIEWSTATE = 139,
    EXPORTFORMAT = 140,
    DRAFT = 162,
    PUBLICATION = 163,
    PUBLICATION_CHANNEL = 165,
    PUBLICATIONLIST = 164,
    DISCOVER_ITEM = 166,
    DISCOVER_WIRE = 167,
    _SEARCH = 999,
}

export const objectTypeReverseMapping: { [key: number]: string } = {
    [ObjectTypes.UNASSIGNED]: 'Unassigned',
    [ObjectTypes.WIRE]: 'Wire',
    [ObjectTypes.RUNDOWN]: 'Rundown',
    [ObjectTypes.SCRIPT]: 'Script',
    [ObjectTypes.AUDIO]: 'Audio',
    [ObjectTypes.VIDEO]: 'Video',
    [ObjectTypes.PICTURE]: 'Picture',
    [ObjectTypes.READIN]: 'Readin',
    [ObjectTypes.PLANNING]: 'Planning',
    [ObjectTypes.MESSAGE]: 'Message',
    [ObjectTypes.GRID]: 'Grid',
    [ObjectTypes.CONTACT]: 'Contact',
    [ObjectTypes.NGGRID]: 'NGGrid',
    [ObjectTypes.MOSOBJ]: 'MosObj',
    [ObjectTypes.ELECTION]: 'Election',
    [ObjectTypes.MOSOBJR]: 'MosObjR',
    [ObjectTypes.OPENS]: 'Opens',
    [ObjectTypes.APWORKBENCH]: 'APWorkbench',
    [ObjectTypes.EXTERNAL]: 'External',
    [ObjectTypes.NONENPS]: 'NonENPS',
    [ObjectTypes.STORYBOARD]: 'Storyboard',
    [ObjectTypes.SEARCH]: 'Search',
    [ObjectTypes.GLOBALMACRO]: 'GlobalMacro',
    [ObjectTypes.RUNDOWNMACRO]: 'RundownMacro',
    [ObjectTypes.STORYMACRO]: 'StoryMacro',
    [ObjectTypes.SOCIALMEDIAPOST]: 'SocialMediaPost',
    [ObjectTypes.SOCIALMEDIACOLLECTION]: 'SocialMediaCollection',
    [ObjectTypes.USER]: 'User',
    [ObjectTypes.PERSONALFOLDER]: 'PersonalFolder',
    [ObjectTypes.PRINTER]: 'Printer',
    [ObjectTypes.WIREFOLDER]: 'WireFolder',
    [ObjectTypes.TRASHOPEN]: 'TrashOpen',
    [ObjectTypes.TRASHCLOSED]: 'TrashClosed',
    [ObjectTypes.LOCATIONS]: 'Locations',
    [ObjectTypes.HOMEFOLDER]: 'HomeFolder',
    [ObjectTypes.GROUPFOLDER]: 'GroupFolder',
    [ObjectTypes.MOSLOGO]: 'MosLogo',
    [ObjectTypes.DIRECTOR]: 'Director',
    [ObjectTypes.EDITOR]: 'Editor',
    [ObjectTypes.RESEARCHER]: 'Researcher',
    [ObjectTypes.LOCATIONFOLDER]: 'LocationFolder',
    [ObjectTypes.WELCOME]: 'Welcome',
    [ObjectTypes.VOIPMESSAGE]: 'VoipMessage',
    [ObjectTypes.COMMCENTER]: 'CommCenter',
    [ObjectTypes.TOOLBOX]: 'Toolbox',
    [ObjectTypes.MACRO]: 'Macro',
    [ObjectTypes.SCHEDULER]: 'Scheduler',
    [ObjectTypes.MYENPS]: 'MyENPS',
    [ObjectTypes.SOCIALMEDIA]: 'SocialMedia',
    [ObjectTypes.COLLECTIONCOLUMN]: 'CollectionColumn',
    [ObjectTypes.TOPIC]: 'Topic',
    [ObjectTypes.ASSIGNMENT]: 'Assignment',
    [ObjectTypes.PSTVIEWSTATE]: 'PSTViewState',
    [ObjectTypes.EXPORTFORMAT]: 'ExportFormat',
    [ObjectTypes.DRAFT]: 'Draft',
    [ObjectTypes.PUBLICATION]: 'Publication',
    [ObjectTypes.PUBLICATION_CHANNEL]: 'PublicationChannel',
    [ObjectTypes.PUBLICATIONLIST]: 'PublicationList',
    [ObjectTypes._SEARCH]: '_SEARCH',
};
